import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

export const useTeamReviewTrackerStyles = makeStyles({
  reviewerInput: {
    width: "100%",
    maxWidth: "220px",
  },
  statusDropdown: {
    minWidth: "140px",
  },
  editableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: designTokens.spacing[2],
    border: `1px dashed ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.md,
    backgroundColor: "transparent",
    padding: `${designTokens.spacing[1]} ${designTokens.spacing[3]}`,
    font: "inherit",
    color: "inherit",
    cursor: "pointer",
    textAlign: "left",
    transition: `border ${designTokens.transition.fast}, background-color ${designTokens.transition.fast}`,
    ":hover": {
      border: `1px dashed ${projectIqTokens.teal}`,
      backgroundColor: projectIqTokens.tealSoft,
    },
    ":focus-visible": {
      border: `1px dashed ${projectIqTokens.teal}`,
      backgroundColor: projectIqTokens.tealSoft,
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "1px",
    },
  },
  addReviewerCell: {
    color: projectIqTokens.tealInk,
    fontWeight: 600,
  },
  cellLabel: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
  },
  trailingIcon: {
    fontSize: designTokens.iconSize.sm,
    flexShrink: 0,
    color: "inherit",
  },
  headerHintIcon: {
    fontSize: designTokens.iconSize.xs,
    marginLeft: designTokens.spacing[1],
    color: projectIqTokens.muted,
    verticalAlign: "middle",
  },
});
